
import { Component, Vue } from 'vue-property-decorator';


import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import FormP1 from "./FormP1.vue";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
import moment from 'moment';
import { stepInfoType } from '@/types/Application';
import { courtLocationInfoType } from '@/types/Common';


@Component({
    components:{
        UnderlineForm,
        CheckBox,
        FormP1
    }
})

export default class FormP9 extends Vue {    

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[]; 

    @applicationState.State
    public deceasedName!: string;

    @applicationState.State
    public applicantName!: string;

    @applicationState.State
    public applicationLocation!: courtLocationInfoType;

    applicantOccupation = '';
    courtName = '';
    deceasedAddress = {};
    applicantMailingAddress = {};
    currentDate = '';
    notifyDeliveryInPerson = [];
    notifyDeliveryMail = [];
    notifyDeliveryElectronic = [];

    dataReady=false

    public getFormData() {
        
        this.courtName = this.applicationLocation.name??''

        //___Applicant
        const applicantInfo = this.steps[this.stPgNo.APPLICANT._StepNo].result?.applicantInfoSurvey?.data;
        this.applicantMailingAddress = applicantInfo?.applicantOrdinaryAddress??{};
        this.applicantOccupation = applicantInfo?.applicantOccupation??'';

        //__Notify
        const notifyInfo = this.steps[this.stPgNo.NOTIFY._StepNo].result?.notifyPeopleSurvey?.data
        if(notifyInfo?.totalRecipients>0){
            for(let inx=0;inx<notifyInfo?.totalRecipients; inx++){
                const deliveryMethod = notifyInfo?.[`notifyP1DeliveryMethod[${inx}]`]
                const deliveryInfo = {
                    notifyDate: notifyInfo?.[`notifyP1DeliveryDate[${inx}]`],
                    recipientName: notifyInfo?.[`recipientName[${inx}]`]
                }
                if(deliveryMethod=='inperson')
                    this.notifyDeliveryInPerson.push(deliveryInfo)
                else if(deliveryMethod=='mail')
                    this.notifyDeliveryMail.push(deliveryInfo)
                else if(deliveryMethod=='electronic')
                    this.notifyDeliveryElectronic.push(deliveryInfo)
            }
        }
    }

    mounted(){
        this.dataReady=false
        this.currentDate = moment().format("MMMM DD, yyyy")
        this.getFormData();
        this.dataReady=true
        Vue.nextTick(() => this.onPrint(false));
    }

    public onPrint(openDownload) {        
        const elP9= document.getElementById("print-p9");
        const elP9Exhibit= document.getElementById("print");
        // console.log(el)        
        const bodyP9 = Vue.filter('printPdf')(elP9.innerHTML,`"Generated by “Representation Grant” on ${this.currentDate}.         "`,`"P9 "`);
        const bodyP9Exhibit = Vue.filter('printPdf')(elP9Exhibit.innerHTML,`"Generated by “Representation Grant” on ${this.currentDate}.         "`,`"P9 Exhibit A "`);
        this.$emit('onPrint',[...bodyP9 , ...bodyP9Exhibit],openDownload)
    }

}
